module.exports = __webpack_public_path__ + "img/icono-impresion.b2176f13.png";